import React from "react";
/**
 * 提取子结点中纯文本
 */
export function getPlainText(node) {
    var text = [];
    var traverse = function (children) {
        if (!children) {
            return;
        }
        React.Children.forEach(children, function (child) {
            if (React.isValidElement(child) && child.props.children) {
                traverse(child.props.children);
            }
            else if (typeof child === "number" || typeof child === "string") {
                text.push(String(child));
            }
        });
    };
    traverse(node);
    return text.join(" ");
}
//# sourceMappingURL=getPlainText.js.map